import { Typography } from 'hype-ds';
import { ValidateBasketProductAmountResponse } from 'services/basket/interfaces';

export const conflictMessages = {
	UPDATE: (
		<Typography.Paragraph.M whiteSpace="pre-line">
			Um dos produtos desta promoção já está no seu pedido com uma condição comercial diferente. {'\n'} Para incluí-lo
			nesta promoção, remova-o do pedido primeiro e adicione novamente.
		</Typography.Paragraph.M>
	),
	ADD: (
		<Typography.Paragraph.M whiteSpace="pre-line">
			Um dos itens desta promoção já está incluído em outra promoção do seu pedido. {'\n'} Um mesmo produto não pode
			participar de duas promoções ao mesmo tempo. {'\n'} Acesse o pedido para verificar e ajustar.
		</Typography.Paragraph.M>
	),
};

export const getConflictDialogContent = (productType?: ValidateBasketProductAmountResponse['productType']) => {
	return {
		heading: {
			title: productType === 'COMBO' ? 'Promoção não pode ser atualizada' : 'Produto já está no carrinho',
			showCloseButton: true,
		},
		content: {
			children: conflictMessages.UPDATE,
		},
		footer: {
			primaryButton: {
				label: 'Entendi',
			},
		},
	};
};
